import { CourseRecommendation } from '@yandex-int/k-common';
import { H2, SimpleText, Text } from 'platform-components';
import { UI_KIT_HEADER_TYPOGRAPHY, UI_KIT_TEXT_TYPOGRAPHY } from 'platform-components/constants';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import ym from 'react-yandex-metrika';

import * as teamSelectors from 'common.components/classes/selectors';

import AddLessonButton from '../../course-view/__add-lesson-button/course-view__add-lesson-button';

import './overview-banner__empty.scss';

interface Props {
    courseId: number | null;
    currentRecommendation?: CourseRecommendation;
}

export const EmptyBanner = (props: Props) => {
    const { courseId } = props;
    const { classId, subject } = useParams<Record<string, string>>();
    const teamStudents = useSelector((store) => teamSelectors.getStudents(store, { classId }));
    const textId =
        teamStudents && teamStudents.length > 0
            ? 'courseView.overviewBanner.noRecommendations.addLesson'
            : 'courseView.overviewBanner.noRecommendations.addKids';

    const sendMetrikaByCreateLesson = () =>
        ym('reachGoal', 'create_lesson_banner_click', {
            course_id: courseId,
            subject,
        });

    useEffect(() => {
        if (!courseId) {
            return;
        }

        ym('reachGoal', 'create_lesson_banner_shown', {
            course_id: courseId,
            subject,
        });
    }, [courseId, subject]);

    return (
        <>
            <div className="overview-banner__problem-skills">
                <div>
                    <H2 mix="overview-banner__section-title" typography={UI_KIT_HEADER_TYPOGRAPHY.headlineXXSMedium}>
                        <SimpleText id="courseView.overviewBanner.noRecommendations.title" />
                    </H2>
                </div>
                <Text id={textId} typography={UI_KIT_TEXT_TYPOGRAPHY.paragraphMRegular} />
            </div>
            <AddLessonButton mix="overview-banner__button" sendMetrikaByCreateLesson={sendMetrikaByCreateLesson} />
        </>
    );
};
